import React from 'react';
import SVGImage from '../layout/SVGImage';
import { useTranslation } from 'react-i18next';

interface ExcelExportButtonProps {
  testId?: string;
  className?: string;
  text?: string;
}

export const ExcelExportButton: React.FC<ExcelExportButtonProps> = ({
  testId,
  className,
  text,
}) => {
  const { t } = useTranslation();
  return (
    <div
      data-testid={testId}
      className={`flex h-[36px] w-[128px] cursor-pointer items-center justify-center rounded-[5px] bg-[#DFEDE1] ${className}`}
    >
      <SVGImage name="excel" />
      <span className="noto-13-medium ml-[10px] leading-[23px] text-[#105F14]">
        {text ?? t('common.excelExport')}
      </span>
    </div>
  );
};
